import { selectHasToken } from "app/store/slices/authorisation";
import { usePrefetchResidents } from "./prefetch/usePrefetchResidents";
import { selectCompleteInitialChecks } from "app/store/slices/overlay";
import { useSelector } from "react-redux";
import { usePrefetchLocations } from "./prefetch/usePrefetchLocations";
import { RootState } from "app/services/store";
import { usePrefetchFormEntries } from "./prefetch/usePrefetchFormEntries";
import { usePrefetchMedicationLogs } from "./prefetch/usePrefetchMedicationLogs";
import { usePrefetchMedicationsActive } from "./prefetch/usePrefetchMedicationsActive";
import { usePrefetchMedicationsHistory } from "./prefetch/usePrefetchMedicationsHistory";
import { usePrefetchPendingSignatureMedications } from "./prefetch/usePrefetchPendingSignatureMedications";
import { usePrefetchForms } from "./prefetch/usePrefetchForms";
import { usePrefetchFluidIntake } from "./prefetch/usePrefetchFluidIntake";
import { usePrefetchBowelMovements } from "./prefetch/usePrefetchBowelMovements";
import { usePrefetchFluidOutput } from "./prefetch/usePrefetchFluidOutput";
import { DISABLE_OFFLINE_RETRIEVAL } from "app/config";

export function useOfflinePrefetch() {
  const enabled = useSelector(selectCompleteInitialChecks);
  const hasToken = useSelector(selectHasToken);
  const isInternetReachable = useSelector(
    (state: RootState) => state.network?.networkState?.isInternetReachable,
  );

  const prefetchEnabled =
    enabled && hasToken && isInternetReachable && !DISABLE_OFFLINE_RETRIEVAL;
  usePrefetchResidents({ enabled: prefetchEnabled });
  usePrefetchLocations({ enabled: prefetchEnabled });
  usePrefetchFormEntries({ enabled: prefetchEnabled });
  usePrefetchMedicationLogs({ enabled: prefetchEnabled });
  usePrefetchMedicationsActive({ enabled: prefetchEnabled });
  usePrefetchMedicationsHistory({ enabled: prefetchEnabled });
  usePrefetchPendingSignatureMedications({ enabled: prefetchEnabled });
  usePrefetchForms({ enabled: prefetchEnabled });
  usePrefetchFluidIntake({ enabled: prefetchEnabled });
  usePrefetchBowelMovements({ enabled: prefetchEnabled });
  usePrefetchFluidOutput({ enabled: prefetchEnabled });
}
